import Model from '@/core/classes/Model'
import { Unauthorized } from '../errors/Entitlement.errors'

export default class Entitlement extends Model {
  /**
   * Check if entitlement has all provided actions
   *
   * @param {Array} actions
   * @param {Boolean} throwError false
   * @param {Boolean} strict true [must pass all entitlement's actions]
   *
   * @return {Boolean}
   */
  can (actions, { throwError = false, strict = true } = {}) {
    return actions.reduce((isPassed, action) => {
      const hasAction = this.get('actions').indexOf(action) !== -1 ||
        this.get('actions').indexOf('*') !== -1

      if (throwError && !hasAction) {
        throw new Unauthorized({ entitlementName: this.entitlementName(), actionName: action })
      } else {
        return strict
          ? hasAction && isPassed
          : hasAction || isPassed
      }
    }, strict)
  }

  /**
   * Check if entitlement has any of provided actions
   *
   * @param {Array} actions
   * @param {Boolean} throwError false
   *
   * @return {Boolean}
   */
  anyCan (actions, { throwError = false } = {}) {
    return this.can(actions, { throwError, strict: false })
  }

  /**
   * Get entitlement name
   */
  entitlementName () {
    return this.get(this.$primaryKey())
  }
}
